import { parseNotesToDraft } from "@reactive-resume/schema";

export const parsePlainTextToDraft = parseNotesToDraft;
